const ZERO_WIDTH_SPACE = "\u200B";

export const getSelectionSafe = () => {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return null;
    return selection;
}

export const isEditorEmpty = ({ root }) => {
    if (!root) return true;

    const text = root.textContent?.replace(/\u200B/g, "").trim();
    if (text) return false;

    const firstP = root.querySelector("p");
    if (!firstP) return true;

    // Only contains <br> or empty
    return firstP.childNodes.length === 0 ||
        (firstP.childNodes.length === 1 &&
            firstP.firstChild?.nodeName === "BR");
}

export const setCursorInside = ({ node }) => {
    const selection = window.getSelection();
    if (!selection) return;

    const range = document.createRange();
    range.setStart(node, 1);
    range.collapse(true);

    selection.removeAllRanges();
    selection.addRange(range);
}

export const applyInlineWhenEmpty = ({
    root,
    tagName
}) => {
    const p = root.querySelector("p");
    if (!p) return;

    const el = document.createElement(tagName);
    el.textContent = ZERO_WIDTH_SPACE;

    p.innerHTML = "<br>";
    p.appendChild(el);

    if (el.firstChild) {
        setCursorInside({ node: el.firstChild });
    }
}

export const registerInlineFormat = ({
    editor,
    commandName,
    tagName,
    execCommandName
}) => {
    editor.commands?.register(commandName, () => {
        const selection = getSelectionSafe();
        if (!selection) return;

        if (isEditorEmpty({ root: editor.root })) {
            applyInlineWhenEmpty({ root: editor.root, tagName });
        } else {
            document.execCommand(execCommandName);
        }
    });
}